export const walletConfigKeys: string[] = [
  'particleEVM, particleSolana, network.particle',
  'coinbaseWallet, coinbaseWalletSDK, com.coinbase.wallet',
  'metaMask, io.metamask, io.metamask.mobile',
  'phantom, app.phantom',
  'okxWallet, oKExWallet, com.okex.wallet',
  'bitKeep, bitget, com.bitget.web3',
  'rabby, io.rabby',
  'rainbow, me.rainbow',
  'talisman, xyz.talisman',
  'trust, trustWallet, com.trustwallet.app',
  'com.crypto.wallet',
  'frontier, xyz.frontier.wallet',
  'zerion, io.zerion.wallet',
  'tokenPocket, pro.tokenpocket',
  'safePal, https://www.safepal.com/download',
  'coin98, coin98.com',
  'onekey, so.onekey.app.wallet',
  'bybitWallet, com.bybit',
  'braveWallet, com.brave.wallet',
  'mantaWallet,manta.network',
];
